import Swal from "sweetalert2";

export const typeChecker = (input, type) => {
	switch(type){
		case 'mobile':
			let mobile_regex = new RegExp(/^09\d{9}$/);
			return mobile_regex.test(input);
		case 'otp_code':
			let otp_code_regex = new RegExp(/\b\d{5}\b/g);
			return otp_code_regex.test(input);
		case 'title':
			return input.length >= 3;
		case 'national_id':
			let national_id_regex = new RegExp(/^[0-9]{10}$/);
			return national_id_regex.test(input);
		case 'image':
			return input.length >= 2;
		case 'number':
			return !isNaN(input);
		case 'uuid':
			let uuid_regex = new RegExp(/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi);
			return uuid_regex.test(input);
		case 'rate':
			return !!input && !isNaN(input) && input<=5 && input>=0;
		case 'shamsi-date':
			let shamsi_date_regex = new RegExp(/^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/);
			return  shamsi_date_regex.test(input);
		default:
			return false;
	}
};

export const commafy = (input, type="value") => {
	if(!input && input !== 0)
		return;
	if(type === "value")
		return input.toString().replaceAll(',', '').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	input.target.value = input.target.value.toString().replaceAll(',', '').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const decommafy = (value) => {
	return value.toString().replaceAll(',', '');
};

export const toEnglishDigits = value => {
	return value.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)).replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
}

export const swal = (statements, options) => {
    Swal.fire({
        title: '',
        text: '',
        icon: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: true,
        confirmButtonText: 1,
        cancelButtonText: 2,
		...options
    }).then(async result => {
        if(result.isConfirmed)
            statements();
    });
}

